import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from '@mui/material';
const ScoreChip = ({ type, label, size = 'medium' }) => {
    return _jsx(Chip, { size: size, variant: 'soft', color: type, label: label });
};
export default ScoreChip;
